// extracted by mini-css-extract-plugin
module.exports = {"top":"ncYVD","prodInfo":"o_rqO","infoRight":"_1zQ1B","content":"_283Ho","chart":"_2F3qI","sidebar":"_17eOK"};